import { gql } from '@apollo/client'

export interface DealLoadStatusRequestInput {
  request: {
    dealId: number
    userId: string
  }
}

export interface DealLoadStatusResponse {
  dealLoadStatus: {
    dealStatus: string
    didError: boolean
    errorMessage: string
    isCurrentVersionDeal: boolean
    versionStatus: string
  }
}

export const GET_DEAL_LOAD_STATUS = gql`
  query GetDealLoadStatus($request: DealLoadStatusRequestInput!) {
    dealLoadStatus(request: $request) {
      dealStatus
      didError
      errorMessage
      isCurrentVersionDeal
      versionStatus
    }
  }
`
